import { FC } from 'react';
import { DeleteSquareXButton } from '../../assets/images/components/NudosComponents';
import { IOrganizationCoupon } from '../../types/coupons.types';
import './CouponCard.scss';

export interface ICouponCard {
  couponData: IOrganizationCoupon;
  handleDelete?: (id: number) => void;
}

/**
 * Componente que muestra un cupón con su código y valor
 * @param {Object} props - Propiedades del componente
 * @param {IOrganizationCoupon} props.couponData - Datos del cupón
 * @param {function} props.handleDelete - Función para eliminar el cupón
 * @returns {JSX.Element} - Componente del cupón
 */
const CouponCard: FC<ICouponCard> = ({ couponData, handleDelete }: ICouponCard) => {
  const { orderId, logisticServiceId } = couponData?.couponApplication || {};
  const applicationType = orderId ? 'Orden' : 'SL';
  const applicationId = orderId ? orderId : logisticServiceId;

  return (
    <div className="couponCard">
      <div className="couponInfo">
        <div className="couponCode">Código: {couponData?.code}</div>

        <div className="bottomSection">
          <div className="couponValue">Valor: {couponData?.discountAmount} usd</div>
          {applicationId && <div className="couponApplication">{`${applicationType} ${applicationId}`}</div>}
        </div>
      </div>

      {handleDelete && (
        <div className="deleteButton" onClick={() => handleDelete?.(couponData?.id)}>
          <DeleteSquareXButton />
        </div>
      )}
    </div>
  );
};

export default CouponCard;
